import AdminIntegrationsRoot from "@/src/components/admin-area/integrations/AdminIntegrationsRoot.vue";
import WorkflowMappingIndex from "@/src/components/admin-area/integrations/omni-life/WorkflowMappingIndex.vue";
import UserMappingIndex from "@/src/components/admin-area/integrations/omni-life/UserMappingIndex.vue";
import { setAdminBreadCrumb } from "@/src/routes/admin-routes.js";
import { PermissionNames } from "@/src/enums";
import ServiceIndex from "@/src/components/admin-area/integrations/email-notifications/ServiceIndex.vue";
import ServiceEdit from "@/src/components/admin-area/integrations/email-notifications/ServiceEdit.vue";

export const adminIntegrationRoutes = [
  {
    path: 'integrations',
    beforeEnter: [ setAdminBreadCrumb ],
    children: [
      {
        path: '',
        name: 'admin_integrations_root',
        component: AdminIntegrationsRoot,
        beforeEnter: [ setAdminBreadCrumb ],
        meta: {
          permissions: [PermissionNames.ADMIN_INTEGRATIONS_OMNILIFE_WORKFLOWS]
        }
      },
      {
        path: 'omnilife',
        children: [
          {
            path: '',
            name: 'admin_integrations_omnilife',
            component: AdminIntegrationsRoot,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_INTEGRATIONS_OMNILIFE_WORKFLOWS]
            }
          },
          {
            path: 'workflow_mappings',
            name: 'admin_integrations_omnilife_workflow_mappings',
            component: WorkflowMappingIndex,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_INTEGRATIONS_OMNILIFE_WORKFLOWS]
            }
          },
          {
            path: 'user_mappings',
            name: 'admin_integrations_omnilife_user_mappings',
            component: UserMappingIndex,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_INTEGRATIONS_OMNILIFE_WORKFLOWS]
            }
          }
        ]
      },
      {
        path: 'email_notifications',
        beforeEnter: [ setAdminBreadCrumb ],
        children: [
          {
            path: '',
            name: 'admin_integrations_email_notifications',
            component: ServiceIndex,
            meta: {
              permissions: [PermissionNames.ADMIN_INTEGRATIONS_EMAIL_NOTIFICATIONS]
            }
          },
          {
            path: 'new',
            name: 'admin_integrations_email_notifications_new',
            component: ServiceEdit,
            meta: {
              permissions: [PermissionNames.ADMIN_INTEGRATIONS_EMAIL_NOTIFICATIONS],
              permissionsKey: 'create'
            }
          },
          {
            path: ':id',
            name: 'admin_integrations_email_notifications_edit',
            component: ServiceEdit,
            meta: {
              permissions: [PermissionNames.ADMIN_INTEGRATIONS_EMAIL_NOTIFICATIONS],
              permissionsKey: 'write'
            }
          }
        ]
      }
    ]
  }
]